<template>
  <button
    class="circular-icon-button"
    :class="{ active }"
    :style="{ background }"
    @click="handleClick"
  >
    <icon
      :name="iconName"
      class="button-icon"
      :style="iconStyles"
      :variant="iconVariant"
    />
    <div
      v-if="showNotification"
      class="notification-dot"
    />
  </button>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  name: 'CircularIconButton',
  components: {
    Icon,
  },
  props: {
    background: {
      type: String,
      default: 'white',
    },
    iconName: {
      type: String,
      required: true,
    },
    iconSize: {
      type: Number,
      default: 20,
    },
    iconWidth: {
      type: Number,
      default: null,
    },
    iconHeight: {
      type: Number,
      default: null,
    },
    iconHorizontalShift: {
      type: Number,
      default: null,
    },
    iconVerticalShift: {
      type: Number,
      default: null,
    },
    iconVariant: {
      type: String,
      default: '',
    },
    showNotification: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    iconStyles() {
      const horizontalShift = this.iconHorizontalShift ?? 0;
      const verticalShift = this.iconVerticalShift ?? 0;
      return {
        transform: `translateX(${horizontalShift}px) translateY(${verticalShift}px)`,
        width: this.iconWidth ? `${this.iconWidth}px` : `${this.iconSize}px`,
        height: this.iconHeight ? `${this.iconHeight}px` : `${this.iconSize}px`,
      };
    },
  },
  methods: {
    handleClick() {
      if (!this.active) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.circular-icon-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--Colors-Border-border-primary, rgba(213, 215, 218, 1));
  border-radius: 50%;
  box-sizing: border-box;
  padding: 0;
  cursor: pointer;
}

.circular-icon-button.active {
  cursor: default;
  border: none;
  z-index: 0;
}

.circular-icon-button.active::before {
  content: '';
  position: absolute;
  inset: 0;
  padding: 2px; /* border thickness */
  border-radius: inherit;
  background: conic-gradient(
    from 0deg,
    var(--Colors-Border-border-primary),
    #ffffff,
    var(--Colors-Border-border-primary),
    #ffffff,
    var(--Colors-Border-border-primary),
  );
  /* CUT OUT THE CENTER */
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  z-index: -1;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.notification-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background: var(--Component-colors-Utility-Error-utility-error-500, rgba(240, 68, 56, 1));
  border: 1.5px solid rgba(252, 252, 253, 1);
  border-radius: 50%;
  box-sizing: border-box;
}
</style>
